var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:clock-filled",
    clipPath: "url(#clip0_0_230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_0_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 2.22667C12.3388 2.80724 13.1753 3.64035 13.7599 4.64353C14.3445 5.64672 14.6569 6.78518 14.6663 7.94623C14.6757 9.10727 14.3816 10.2506 13.8133 11.2631C13.245 12.2756 12.4222 13.1221 11.4262 13.7189C10.4302 14.3156 9.29558 14.6419 8.13473 14.6654C6.97389 14.6889 5.82703 14.4088 4.8077 13.8528C3.78837 13.2969 2.93191 12.4844 2.32311 11.4957C1.71431 10.507 1.37427 9.37647 1.33667 8.216L1.33333 8L1.33667 7.784C1.374 6.63266 1.70903 5.51064 2.30909 4.52733C2.90915 3.54402 3.75377 2.73297 4.76059 2.17325C5.76742 1.61354 6.9021 1.32426 8.054 1.33363C9.20591 1.34299 10.3357 1.65067 11.3333 2.22667ZM8 4C7.83671 4.00002 7.67911 4.05997 7.55708 4.16848C7.43506 4.27698 7.3571 4.4265 7.338 4.58867L7.33333 4.66667V8L7.33933 8.08733C7.35453 8.203 7.39982 8.31265 7.47067 8.40533L7.52867 8.472L9.52867 10.472L9.59133 10.5267C9.70825 10.6174 9.85202 10.6666 10 10.6666C10.148 10.6666 10.2918 10.6174 10.4087 10.5267L10.4713 10.4713L10.5267 10.4087C10.6174 10.2918 10.6666 10.148 10.6666 10C10.6666 9.85202 10.6174 9.70825 10.5267 9.59133L10.4713 9.52867L9.83772 8.89482C9.08789 8.14471 8.66667 7.12752 8.66667 6.06691V4.66667L8.662 4.58867C8.64289 4.4265 8.56494 4.27698 8.44291 4.16848C8.32089 4.05997 8.16329 4.00002 8 4Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_230",
    x: -73.6667,
    y: -69.6666,
    width: 163.333,
    height: 163.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_230"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_230",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon_clock.2a212dba44f6944fca11cd5fcbed2ec2.svg";
export { ForwardRef as ReactComponent };